import styled from 'styled-components';

import { BaseStyle, ReactTableStyles } from '@nhl/nhl-breakaway-ui';

export const PositionTitle = styled.h5`
    padding-bottom: 20px;
`;

export const RosterHeader = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    justify-content: center;
    margin-bottom: 24px;

    h1 {
        ${BaseStyle.Mixins.gaps.large}
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 24px;
        max-width: 1vw;
    }

    ${BaseStyle.Mixins.screenSizes.medium} {
        grid-template-columns: 1fr 159px;
        margin-bottom: 40px;

        h1 {
            justify-content: flex-start;
        }
    }
`;

export const RosterTableContainer = styled.div`
    margin-bottom: 30px;

    ${ReactTableStyles.CommonTableStyling}

    .rt-table-container {
        ${ReactTableStyles.TableScrollShadows};
    }

    .rt-table {
        .rt-tbody .rt-tr:hover {
            border: 1px solid ${({ theme }) => theme.Table.outline};
        }
    }
`;

export const BirthplaceColumn = styled.div`
    text-wrap: unset;
`;
